class HeroBackgroundVideo {
    constructor() {
        this.hero = document.querySelector('.hero-background-video')

        if ( null !== this.hero ) {
            this.setVideoRatio()
            window.addEventListener( 'resize', this.setVideoRatio.bind(this), { passive: true } );
        }
    }

    setVideoRatio() {
        const ratio = this.hero.offsetHeight / this.hero.offsetWidth * 100;
        
        this.hero.classList.toggle( 'hero-background-video--portrait' , ratio > 56.25 );
    }
}

new HeroBackgroundVideo();